
import React, { useEffect, useRef } from 'react';
import { Clock } from 'lucide-react';
import { Progress } from '@/components/ui/progress';

interface QuizTimerProps {
  timeLeft: number;
  totalTime: number;
  onTimeUp: () => void;
}

const QuizTimer: React.FC<QuizTimerProps> = ({ timeLeft, totalTime, onTimeUp }) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  
  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  const timeProgress = (timeLeft / totalTime) * 100;

  return (
    <div className="space-y-2">
      <div className="flex justify-between text-sm">
        <span>Time Remaining</span>
        <span className={`flex items-center gap-1 ${timeLeft < 60 ? 'text-red-400' : 'text-white'}`}>
          <Clock className="h-4 w-4" />
          {formatTime(timeLeft)}
        </span>
      </div>
      <Progress 
        value={timeProgress} 
        className="bg-forest h-2" 
        indicatorClassName={`${timeLeft < 300 ? 'bg-red-500' : 'bg-mint'}`} 
      />
    </div>
  );
};

export default QuizTimer;
